import React from "react";
import { HStack } from "native-base";
import { Link } from "react-router-dom";
import Svg from "react-native-svg";
import { COLORS } from "../../utils/colors";
import { breadCrumbsArrowSVG } from "../../utils/svg";
import { COMMONFONTSIZE } from "../../utils/fonts";

const Breadcrumbs = ({ path }) => {
  return (
    <HStack space={2} alignItems={"center"}>
      <Link
        style={{
          textDecoration: "none",
          color: "rgba(0, 0, 0, 0.50)",
          fontSize: COMMONFONTSIZE.MEDIUM_FONT_SIZE,
        }}
        to={path?.activeTab?.path}
      >
        {path?.activeTab?.name}
      </Link>
      {path?.activeMenu?.name !== "" && (
        <>
          <Svg width="16" height="17" viewBox="0 0 16 17">
            {breadCrumbsArrowSVG}
          </Svg>
          <Link
            style={{
              textDecoration: "none",
              color: COLORS.BLACK_COLOR,
              fontSize: COMMONFONTSIZE.MEDIUM_FONT_SIZE,
            }}
            to={path?.activeMenu?.path}
          >
            {path?.activeMenu?.name}
          </Link>
        </>
      )}
      {path?.activeActivePage?.name !== "" && (
        <>
          <Svg width="16" height="17" viewBox="0 0 16 17">
            {breadCrumbsArrowSVG}
          </Svg>
          <Link
            style={{
              textDecoration: "none",
              color: COLORS.BLACK_COLOR,
              fontSize: COMMONFONTSIZE.MEDIUM_FONT_SIZE,
            }}
            to={path?.activeActivePage?.path}
          >
            {path?.activeActivePage?.name}
          </Link>
        </>
      )}
    </HStack>
  );
};

export default Breadcrumbs;
